import { ElInput } from 'element-ui/types/input';
import _ from 'lodash';

import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

import mask from './inputMask/directive';

enum Case {
	Upper = 'upper',
	Lower = 'lower',
}
export const SimpleInputConstructor = BaseInput.extend({
	name: 'DmsSimpleInput',
	components: { DmsWrapper },
	directives: { mask },
	props: {
		mask: { type: String, default: undefined },
		type: { type: String, default: 'text' },
		rows: Number,
		autosize: [Boolean, Object],
		uppercase: Boolean,
		suffixText: { type: String, default: '' },
		required: { type: Boolean, default: undefined },
		autofocus: { type: Boolean, default: undefined },
		isAutocomplete: { type: Boolean, default: false },
		noLabelAlign: { type: Boolean, default: false },
		fetchSuggestions: { type: Function, default: () => { } },
		maxlength: { type: Number },
	},
	computed: {
		extraAttrs(): { min?: number, max?: number, maxlength?: number } {
			return {
				min: this.min,
				max: this.max,
				maxlength: this.maxlengthCmp,
			};
		},
		max(): number | undefined {
			return this.getNumberRule('max');
		},
		min(): number | undefined {
			return this.getNumberRule('min');
		},
		maxlengthCmp(): number | undefined {
			return this.maxlength || this.max;
		},
		getElInput(): ElInput | null {
			return this.$refs.elInput as ElInput | null;
		},
		rules(): any | null {
			return this.formItem?.allRules;
		},
		maskComputed(): string | undefined {
			return this.mask ?? this.getRule('maska');
		},
		isUpperCase(): boolean {
			return this.uppercase || this.getRule('case') === Case.Upper;
		},
		isLowerCase(): boolean {
			return this.getRule('case') === Case.Lower;
		},
	},
	mounted() {
		this.$refs.wrapper && (this.formItem = (this.$refs.wrapper as any).formItem);
		if (this.autofocus) {
			this.focus();
		}
	},
	methods: {
		focus() {
			this.$nextTick(() => this.getElInput && this.getElInput.focus());
		},
		inputEvent(event: string): void {
			if (this.isUpperCase) {
				this.$emit('update:value', event.toUpperCase());
			} else if (this.isLowerCase) {
				this.$emit('update:value', event.toLowerCase());
			} else {
				this.$emit('update:value', event);
			}
		},
		getNumberRule(name: string): number | undefined {
			const rule = this.getRule(name);
			return _.isNumber(rule) ? rule : undefined;
		},
		getRule(name: string): any {
			const rule = this.rules?.find((item: Record<string, number>) => !!item[name]);
			return rule ? rule[name] : undefined;
		},
	},
});

// eslint-disable-next-line
export default SimpleInputConstructor;
